import React, { useState, useEffect } from "react";
import Result from "./Result";
import Photos from "./Photos";
import axios from "axios";
import "./Search.css";

export default function Search({ defaultKeyword }) {
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [result, setResult] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  async function search(currentKeyword) {
    if (!currentKeyword) return;

    setIsLoading(true);
    setError(null);

    // 🔹 Dictionary Request
    try {
      const dictionaryUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${currentKeyword}`;
      const dictionaryRes = await axios.get(dictionaryUrl);
      setResult(dictionaryRes.data[0]);
    } catch (err) {
      setResult(null);
      if (err.response?.status === 404) {
        setError("Word not found.");
      } else {
        setError("Dictionary API failed.");
      }
    } finally {
      setIsLoading(false);
    }

    // 🔹 Pexels Request
    try {
      const pexelsUrl = `https://api.pexels.com/v1/search?query=${currentKeyword}&per_page=9`;
      const pexelsKey =
        "d7YcPdCOkhxmWD3BPX1GDgHNPal9cqk9TwBUQTi29G2VOwDEc0K8CBW7";

      const pexelsRes = await axios.get(pexelsUrl, {
        headers: { Authorization: pexelsKey },
      });
      setPhotos(pexelsRes.data.photos);
    } catch (err) {
      console.error("Pexels error:", err);
      setPhotos([]);
    }
  }

  useEffect(() => {
    search(defaultKeyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    search(keyword);
  }

  return (
    <div>
      <section>
        <form onSubmit={handleSubmit} className="search">
          <input
            type="search"
            className="inp1"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="For example sunset"
          />
          <input type="submit" className="bttn" value="Search" />
        </form>
      </section>

      {isLoading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      {result && <Result result={result} />}

      {photos.length > 0 && <Photos photos={photos} />}
    </div>
  );
}
